<ng-container *ngIf="user$ | async as user; else login">
  <div
    nz-dropdown
    nzTrigger="click"
    [nzDropdownMenu]="menu"
    class="flex items-center px-2 py-2 hover:cursor-pointer md:gap-2"
  >
    <span></span>
    @if (user$ | async; as user) {
      <nz-avatar
        [nzSize]="30"
        nzIcon="user"
        [nzSrc]="user.profilePictureUrl"
      ></nz-avatar>
    } @else {
      <nz-avatar [nzSize]="30" nzIcon="user"></nz-avatar>
    }
    <div class="flex flex-col">
      <span class="px-2 text-xs font-bold md:text-sm">
        {{ user$ | async | fullName }}
      </span>
      <div *ngIf="isStaff">
        <span
          class="text-mbaza-text-secondary text-[10px] font-extralight md:text-sm"
        >
          {{ user$ | async | position }}
        </span>
      </div>
    </div>
    <img
      [src]="ASSET_CONSTANTS.I_arrow_down"
      alt="arrow right"
      class="h-5 w-5 grayscale md:h-6 md:w-6"
    />
  </div>
</ng-container>

<ng-template #login>
  <div class="flex flex-col lg:flex-row gap-4 lg:gap-0" *transloco="let t">
    <app-mb-button
      type="text"
      class="w-full hidden lg:block"
      label="{{ t('login') }}"
      size="small"
      (click)="navigateToLogin()"
      htmlType="button"
    />
    <app-mb-button
      type="ghost"
      class="w-full block lg:hidden"
      label="{{ t('login') }}"
      size="small"
      (click)="navigateToLogin()"
      htmlType="button"
    />
    <app-mb-button
      type="secondary"
      class="w-full"
      label="{{ t('register') }}"
      (click)="navigateToRegister()"
      htmlType="button"
      size="small"
    />
  </div>
</ng-template>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul
    nz-menu
    class="min-w-[80px] bg-amber-400 md:min-w-[220px]"
    *transloco="let t"
  >
    <li>
      <div class="flex flex-col space-y-0.5 md:space-y-1">
        <span class="text-sm font-semibold">{{
          user$ | async | fullName
        }}</span>
        <span class="text-mbaza-text-secondary text-sm font-extralight">
          {{ user$ | async | email }}
        </span>
      </div>
    </li>
    <li nz-menu-divider></li>
    <li
      nz-menu-item
      class="py-1.5 md:py-2"
      (click)="onProfileClick()"
      (keydown.enter)="onProfileClick()"
      tabindex="0"
    >
      <app-mb-icon type="user" variant="gray" class="mr-3 md:mr-4" />
      <span class="text-sm text-black">{{ t("myProfile") }}</span>
    </li>
    <li
      nz-menu-item
      class="py-1.5 md:py-2"
      (click)="onSystemSettingsClick()"
      (keydown.enter)="onSystemSettingsClick()"
      tabindex="0"
    >
      <app-mb-icon type="setting" variant="gray" class="mr-3 md:mr-4" />
      <span class="text-sm text-black">{{ t("systemSettings") }}</span>
    </li>
    <li nz-menu-divider></li>
    <li
      nz-menu-item
      class="py-1.5 md:py-2"
      (click)="onLogout()"
      (keydown.enter)="onLogout()"
      tabindex="0"
    >
      <app-mb-icon type="logout" variant="gray" class="mr-3 md:mr-4" />
      <span class="text-mbaza-gray text-sm">{{ t("logout") }}</span>
    </li>
  </ul>
</nz-dropdown-menu>
